import { IWidgetSettingsFormData } from '@/models/Widget/settings';

export function validation(
  formData: IWidgetSettingsFormData,
  onboarding: boolean
) {
  const { enabled, placement, widgetStyle } = formData;
  const { color, launcher, text } = widgetStyle;

  const isValidPosition = Object.entries(placement)
    .map(([key, value]) => {
      if (String(key) === 'positioning') return !!value;

      return Object.values(value).every(val => !isNaN(parseInt(val)));
    })
    .every(Boolean);

  const isValidText = launcher === 'both' && !text;
  if (isValidText) return false;

  return (
    !!color &&
    typeof enabled === 'boolean' &&
    (onboarding || enabled) &&
    isValidPosition
  );
}
